import wdyr from '@welldone-software/why-did-you-render';
// eslint-disable-next-line import/default
import React from 'react';

wdyr(React, {
  // include: [/.*/],
  exclude: [/^BrowserRouter/, /^Link/, /^Route/],
  trackHooks: true,
  logOnDifferentValues: true,
  // trackAllPureComponents: true,
});
